export default "__VITE_ASSET__CpOwZUUy__"